"use client";

import { ChevronDown } from "lucide-react";

export type AccordionProps = {
  title: string;
  content: string;
  id: number;
  isOpen?: boolean;
  toggle?: (id: number) => void;
};

const Accordion = ({ title, content, id, isOpen, toggle }: AccordionProps) => {
  return (
    <div
      onClick={() => toggle && toggle(id)}
      className="w-full lg:max-w-[660px] card-shadow rounded-lg bg-white px-5 py-4 md:py-6 cursor-pointer hover:bg-gray-50 transition-colors block select-none"
    >
      <div className="flex items-center justify-between w-full">
        <h3 className="subtitle-text text-text-secondary">{title}</h3>
        <div
          className={`bg-primary rounded-full size-[28px] flex items-center justify-center text-white transition-transform duration-300 mr-2 shrink-0 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <ChevronDown size={20} />
        </div>
      </div>
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <p className="text-text-secondary mt-6">{content}</p>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
